<script setup>
import Badge from "@Components/Badge.vue";
import { MenuItem } from "@headlessui/vue";
import { twMerge } from "tailwind-merge";
import { computed } from "vue";

defineOptions({
    inheritAttrs: false,
});

const props = defineProps({
    as: { type: [String, Object], default: "div" },
    label: String,
    icon: [Object, Function],
    z: { type: Number, default: 0 },
    tags: { type: Array, default: () => [] },
});

const activeItemClasses = computed(() => {
    let classes = ["bg-gray-100"];

    switch (props.z) {
        case 3:
            classes.push("dark:bg-gray-500");
            break;
        case 2:
            classes.push("dark:bg-gray-600");
            break;
        case 1:
            classes.push("dark:bg-gray-700");
            break;
        default:
            classes.push("dark:bg-gray-800");
            break;
    }

    return twMerge(classes);
});
</script>

<template>
    <MenuItem as="template" v-slot="{ active, selected }">
        <component
            :is="as"
            v-bind="$attrs"
            class="w-full relative block p-1 text-gray-900 cursor-pointer select-none dark:text-white focus:outline-none focus:shadow-none">
            <div :class="[active ? activeItemClasses : '', 'rounded-sm py-2 px-3 flex items-center']">
                <component v-if="icon" :is="icon" class="w-5 h-5 flex-none mr-4" aria-hidden="true" />
                <span :class="[selected ? 'font-semibold' : 'font-normal', 'flex-1 block truncate text-left']">{{ label }}</span>
                <div v-if="tags.length > 0" class="ml-auto flex flex-none items-center gap-2">
                    <Badge v-for="tag in tags" :key="tag" :color="tag.color">{{ tag.label }}</Badge>
                </div>
            </div>
        </component>
    </MenuItem>
</template>
